import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { CaretUpDownIcon, CheckIcon } from "@phosphor-icons/react";

// SR-FIX-01 · searchable Item filter scoped to the ledger items of the selected category + Godown.
export function ItemPicker({ domain, warehouseId, value, onChange, className }) {
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let live = true;
    if (!warehouseId) { setOpts([]); return undefined; }
    api.get("/inventory/v2/stock-report/items", { params: { category: domain, warehouse_id: warehouseId } })
      .then(({ data }) => { if (live) setOpts(data || []); })
      .catch(() => { if (live) setOpts([]); });
    return () => { live = false; };
  }, [domain, warehouseId]);
  useEffect(() => {
    if (value && !opts.some(o => o.id === value)) onChange("");
  }, [opts]); // eslint-disable-line react-hooks/exhaustive-deps
  const sel = opts.find(o => o.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="sr-item" disabled={!warehouseId}
          className={`${className} flex items-center justify-between text-left text-white disabled:opacity-50`}
          title={sel ? sel.code : "All items"}>
          <span className="truncate">{sel ? sel.code : (warehouseId ? "All items" : "Select a Godown first")}</span>
          <CaretUpDownIcon size={12} className="shrink-0 text-zinc-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[420px] bg-[var(--bg-1)] border-[var(--border)] text-white" align="start">
        <Command className="bg-[var(--bg-1)] text-white">
          <CommandInput data-testid="sr-item-search" placeholder="Search item code…" className="text-white" />
          <CommandList className="max-h-72">
            <CommandEmpty className="py-3 text-center text-xs text-zinc-500">No matching item</CommandEmpty>
            <CommandGroup>
              <CommandItem value="__all__ all items" data-testid="sr-item-opt-all" onSelect={() => { onChange(""); setOpen(false); }}
                className="text-xs font-mono text-white aria-selected:bg-[var(--bg-2)]">
                <CheckIcon size={12} className={value ? "opacity-0" : ""} />All items
              </CommandItem>
              {opts.map(o => (
                <CommandItem key={o.id} value={`${o.code} ${o.id}`} data-testid={`sr-item-opt-${o.code}`}
                  onSelect={() => { onChange(o.id); setOpen(false); }}
                  className="text-xs font-mono text-white aria-selected:bg-[var(--bg-2)]">
                  <CheckIcon size={12} className={value === o.id ? "" : "opacity-0"} />{o.code}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
